import Dexie, { Table } from 'dexie';

interface CachedTask {
  id: number;        // task ID — primary key
  data: any;         // full task object dari API
  cached_at: string; // ISO timestamp — kapan di-cache
  user_id: string;   // siapa yang cache (untuk keamanan multi-user)
}

class TaskCacheDB extends Dexie {
  tasks!: Table<CachedTask, number>;

  constructor() {
    super('teratask_task_cache');
    this.version(1).stores({
      tasks: 'id, user_id, cached_at',
    });
  }
}

const db = new TaskCacheDB();

export const taskCache = {
  async save(task: any, userId: string): Promise<void> {
    if (!task?.id) return;
    await db.tasks.put({
      id: task.id,
      data: task,
      cached_at: new Date().toISOString(),
      user_id: userId,
    });
  },

  async get(taskId: number, userId: string): Promise<CachedTask | null> {
    const cached = await db.tasks.get(taskId);
    if (!cached || cached.user_id !== userId) return null;
    return cached;
  },

  async delete(taskId: number): Promise<void> {
    await db.tasks.delete(taskId);
  },
};
